module.exports = __webpack_public_path__ + "assets/img/20230907.9c51584d.png";